import React, { FC } from 'react';
import { Box, Paper, makeStyles, Divider } from '@dxb-web-ui-framework/design-system';
import { PaperProps, BoxProps } from '@dxb-web-ui-framework/design-system';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';

const useStyles = makeStyles(theme => ({
  paperContainer: {
    padding: `${theme.spacing(4)}px ${theme.spacing(3)}px`,
  },
  boxContainer: {
    paddingLeft: `${theme.spacing(3)}px`,
    paddingBottom: `${theme.spacing(3)}px`,
    paddingRight: `${theme.spacing(3)}px`,
    paddingTop: `${theme.spacing(1)}px`,
  },
}));

export interface ContentWrapperProps {
  hasDivider?: boolean;
  boxProps?: BoxProps;
  paperProps?: PaperProps;
}

const ContentWrapper: FC<ContentWrapperProps> = ({ hasDivider, boxProps, paperProps, children }) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  const classes = useStyles();

  if (isMobile) {
    return (
      <>
        <Box className={boxProps ? undefined : classes.boxContainer} {...boxProps} position={isMobile && 'relative'}>
          {children}
        </Box>
        {Boolean(hasDivider) && <Divider />}
      </>
    );
  }

  return (
    <Paper
      elevation={isMobile ? 0 : 1}
      classes={{ root: paperProps ? undefined : classes.paperContainer }}
      {...paperProps}>
      {children}
    </Paper>
  );
};

export { ContentWrapper };
